module.exports = __webpack_public_path__ + "img/finished.4342e832.png";